import { IS_UPDATE_VERSION_3_PROJECT_LOGIN } from '@/helper/const';
import { getCurrentUser } from "@/Redux/futures/account/actions";
import { curStateAccount } from "@/Redux/selector";
import { hasAuthCookie } from "@/utils/auth";
import PATH from "@config/PATH";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const account = useSelector(curStateAccount);
  const { openLogin } = useLoginModal();

  const isAuthed =
    hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

  const [checked, setChecked] = useState(isAuthed);

  const hasHandledInitialAuthRef = useRef(false);

  useEffect(() => {
    if (isAuthed) return;
    dispatch(
      getCurrentUser({
        callback: (res, isLoading) => {
          if (!isLoading && !res?.success) setChecked(true);
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasHandledInitialAuthRef.current) return; // đã xử lý xong lần đầu, bỏ qua mọi thay đổi isAuthed sau đó
    if (!checked) return; // chưa xác định xong phiên, chờ

    hasHandledInitialAuthRef.current = true;
    if (!isAuthed && IS_UPDATE_VERSION_3_PROJECT_LOGIN) {
      openLogin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  if (isAuthed) return children;
  if (!checked) return null;

  if (IS_UPDATE_VERSION_3_PROJECT_LOGIN) {
    return children;
  }

  return <Navigate to={PATH.LOGIN} replace state={{ from: location }} />;
}